import { SortFn } from "../../helper/sort";
import { CAP, COMP_REPEATER, CONNECTOR, IC, IND, RES } from "../../PCBHelper";

function getSchematicCompColor(type) {
  switch (type) {
    case IC:
      return /* "#87CEEB"// */'#f47188';
    case RES:
      return "#FDD5B1"//'#f4b183';
    case IND:
      return /* "#FFEFD5"// */'#e97020ff';
    case CAP:
      return "#C9A0DC"//'#b165cfff';
    case COMP_REPEATER:
      //#44bff7
      //40d798
      return "#1cd3abff"//'#40d798';
    case CONNECTOR:
      /*  return '#f39c12'; */
      return /* "#E6E6FA"// */'#9998ff';
    default:
      return/*  "##BC4DE"// */'#B0C4DE';
  }
}

function getDefaultRootComponents(info) {
  if (!info.content || !info.content.components || !info.content.signals) {
    return {
      pcbId: info.pcbId,
      roots: []
    }
  };
  const _roots = getDefaultRoot(info.content.components, info.content.signals || []);
  return {
    pcbId: info.pcbId,
    roots: _roots
  }
}

function getDefaultRoot(components, signals) {
  const ICComps = components.filter(comp => [IC, CONNECTOR].includes(comp.type)).map(item => item.pins.map(pin => { return { ...pin, compName: item.name, type: item.type } })).flat(2);
  let signalRoots = {}
  for (let signal of signals) {
    const filterCompPins = ICComps.filter(item => item.signal === signal.name);
    signalRoots[signal.name] = [];
    if (!filterCompPins.length) {
      continue;
    }
    const masterComps = filterCompPins.filter(item => item.usage === "Driver").map(it => it.compName);
    const slaveComps = filterCompPins.filter(item => item.usage !== "Driver").map(it => it.compName);

    signalRoots[signal.name].push(...[...new Set(masterComps)], ...[...new Set(slaveComps)])
  }

  const commonComps = findCommonComps(signalRoots, ICComps)
  return commonComps;
}

function findCommonComps(signalRoots, ICComps) {
  const countMap = {};
  const signals = Object.keys(signalRoots);

  for (let signal of signals) {
    const comps = signalRoots[signal] || [];
    for (let comp of comps) {
      if (!countMap[comp]) {
        countMap[comp] = {};
      }
      countMap[comp] = {
        count: (countMap[comp].count || 0) + 1,
        signals: [...(countMap[comp].signals || []), signal]
      }
    }
  }

  // find common
  const globalCommon = Object.keys(countMap).filter(item =>
    countMap[item].count === signals.length
  );

  if (globalCommon.length > 0) {
    const _globalCommon = globalCommon.map(item => { return { name: item, type: ICComps.find(comp => comp.compName === item).type } });
    const sortComps = SortFn(_globalCommon, [IC, CONNECTOR], 'type');
    const filterIcComps = sortComps.filter(item => item.type === IC);
    if (filterIcComps.length > 0) {
      const findIC = filterIcComps.find(item => item.name.startsWith('U')) || {};
      return [findIC.name || filterIcComps[0].name];
    }
    return [sortComps[0].name];
  }

  let existSignals = [], commonCompsList = []
  for (let item of Object.keys(countMap)) {
    const filterSignals = countMap[item].signals.filter(signal => !existSignals.includes(signal));
    if (filterSignals.length > 1) {
      existSignals.push(...countMap[item].signals)
      commonCompsList.push(item)
    }
  }

  return commonCompsList
}

function getInterfaceSetupInfo(setupData) {
  let data = {};
  data.designVersion = setupData.designVersion || "";
  if (!setupData.content) {
    setupData.content = {}
  }
  data.signals = (setupData.content.signals || []).map(item => {
    return {
      name: item.name || "",
      nets: [...item.nets]
    }
  });
  data.components = (setupData.content.components || []).map(item => {
    return {
      name: item.name || "",
      type: item.type || "",
      pins: item.pins.map(pin => {
        return {
          pin: pin.pin || "",
          net: pin.net || ""
        }
      })
    }
  });
  data.powerNets = (setupData.content.powerNets || []).map(item => item.name);
  return data;
}

export {
  getSchematicCompColor,
  getDefaultRootComponents,
  getInterfaceSetupInfo
}